import React from 'react'
import * as echarts from 'echarts'
import ReactECharts from 'echarts-for-react';

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar, Doughnut } from 'react-chartjs-2';

import ChartDataLabels from 'chartjs-plugin-datalabels';


ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);

export default function Barchart(props) {




    const option = {
        tooltip: {

        },
        xAxis: {
            type: 'category',
            data: props.label
        },
        yAxis: {
            type: 'value',
            show: false
        },
        series: [
            {
                data: props.data,
                type: 'bar',
                label: {
                    show: true,
                    position: 'top'
                },
                itemStyle: {
                    // You can directly assign colors to each bar
                    color: function (params) {
                        var colorList = ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd'];
                        return colorList[params.dataIndex];
                    }
                }

            }
        ]
    };

    return (

        <ReactECharts option={option} style={{ height: '200px', width: '100%' }} />
    )
}
